const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function tiktokHotProductReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_TIKTOK_HOT_PRODUCT':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_TIKTOK_HOT_PRODUCT':
			return {
				...state,
				list: action?.payload?.product_hot_rank || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default tiktokHotProductReducer;
